"use client"

import React, { Suspense } from "react"
import MobileNav from "components/NavBar/MobileNav"
import Footer from "layouts/components/Footer"

import { Box, useUserIPLocation } from "@bullseye/components"
import { Banners, UnauthedNavbar } from "@bullseye/ui"

import { OpenInAppBanner } from "../components/OpenInAppBanner"

type Props = {
  children: React.ReactNode
}

export const MainLayout = ({ children }: Props) => {
  const { data: location } = useUserIPLocation()
  return (
    <Box className="relative flex h-full p-0">
      <Banners userLocation={location} />
      <UnauthedNavbar />
      <main className="flex w-full flex-1 flex-col">{children}</main>
      <Footer />
      <MobileNav />
      <Suspense>
        <OpenInAppBanner />
      </Suspense>
    </Box>
  )
}
